<template>
    <div class="background" :style="background+';margin-top:5px;height:'+(window.width>1023?'250px':'125px;')">
        <Title :window="window" :position="'center'" :color="'white'" :chosenMeetingName="chosenMeetingName"/>
    </div>
</template>

<script>
import Title from '@/components/animerPage/components/Title'
export default {
  components: {
    Title
  },
  props: {
    chosenMeetingName: {
      type: String,
    },
    background: {
      type: String,
      required: false
    },
    window: {
      required: true
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/animerPage/components/Bandeau.vue